// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../../../../provider/Context.bs.js";
import * as Atom_Cta from "../../../atom/Atom_Cta.bs.js";
import * as Atom_Row from "../../../atom/Atom_Row.bs.js";
import * as Js_array from "@rescript/std/lib/es6/js_array.js";
import * as Atom_Cell from "../../../atom/Atom_Cell.bs.js";
import * as Atom_Grid from "../../../atom/Atom_Grid.bs.js";
import * as Atom_Text from "../../../atom/Atom_Text.bs.js";
import * as Atom_Image from "../../../atom/Atom_Image.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Atom_Column from "../../../atom/Atom_Column.bs.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Type_Common from "../../../../type/Type_Common.bs.js";
import * as Type_String from "../../../../type/Type_String.bs.js";
import * as Atom_Icon_Css from "../../../atom/Atom_Icon_Css.bs.js";
import * as Molecule_Partners from "../../../molecule/Molecule_Partners.bs.js";
import * as Atom_Icon_Internal from "../../../atom/icon/Atom_Icon_Internal.bs.js";
import * as Particle_Screen_Ds from "../../../particle/Particle_Screen_Ds.bs.js";
import * as Atom_FavoriteButton from "../../../atom/Atom_FavoriteButton.bs.js";
import * as UseTrackingAmplitude from "../../../../hook/UseTrackingAmplitude.bs.js";
import * as Template_ProgramContent from "./Template_ProgramContent.bs.js";
import * as Particle_Screen_Constants from "../../../particle/Particle_Screen_Constants.bs.js";

function renderItems(_items, _parent) {
  while(true) {
    var parent = _parent;
    var items = _items;
    if (parent === undefined) {
      return items;
    }
    var items$1 = Js_array.concat(items, [[
            parent.label,
            parent.url
          ]]);
    _parent = parent.parent;
    _items = items$1;
    continue ;
  };
}

function Template_ProgramContent_Metas$Tags(Props) {
  var parent = Props.parent;
  var items = renderItems([], parent);
  var _trackAmplitude = UseTrackingAmplitude.useUserAction("category_button");
  var onClick = function (param) {
    Curry._1(_trackAmplitude, undefined);
  };
  return React.createElement(Atom_Row.make, {
              blockSpace: Particle_Screen_Constants.xsBottomBlockSpace,
              children: Belt_Array.mapWithIndex(items, (function (index, param) {
                      var label = param[0];
                      return React.createElement(Atom_Cell.make, {
                                  blockSpace: Particle_Screen_Constants.xxsBottomBlockSpace,
                                  kind: /* ItemList */4,
                                  children: React.createElement(Atom_Cta.Link.make, {
                                        href: param[1],
                                        label: label,
                                        onClick: onClick,
                                        style: /* Tag */25
                                      }),
                                  key: label + String(index)
                                });
                    })),
              innerSpace: Particle_Screen_Constants.xsInnerSpace,
              kind: /* List */5
            });
}

var Tags = {
  renderItems: renderItems,
  make: Template_ProgramContent_Metas$Tags
};

function Template_ProgramContent_Metas$VodDvd$Display(Props) {
  var label = Props.label;
  var url = Props.url;
  var availability = Props.availability;
  var _trackAmplitude = UseTrackingAmplitude.useUserAction("VOD_button");
  var onClick = function (param) {
    Curry._1(_trackAmplitude, undefined);
  };
  return React.createElement(Atom_Row.make, {
              alignItems: Particle_Screen_Constants.alignItemsCenter,
              blockSpace: Particle_Screen_Constants.lTopBlockSpace,
              children: null,
              wrap: /* OnOneLine */1
            }, React.createElement(Atom_Cell.make, {
                  width: Particle_Screen_Ds.make(undefined, undefined, undefined, Css.pct(50), undefined, "auto"),
                  children: React.createElement(Atom_Cta.Link.make, {
                        href: url,
                        label: label,
                        onClick: onClick,
                        style: /* BuyProgram */7,
                        target: "Blank"
                      })
                }), React.createElement(Atom_Image.ImageFromCdn.make, {
                  alt: "",
                  style: {
                    TAG: /* FromCdn */1,
                    _0: {
                      TAG: /* BuyProgram */1,
                      _0: availability
                    }
                  }
                }));
}

var Display = {
  make: Template_ProgramContent_Metas$VodDvd$Display
};

function Template_ProgramContent_Metas$VodDvd(Props) {
  var shopUrl = Props.shopUrl;
  var match = Context.Config.getState(undefined);
  var vodStoreHomepageUrl = match.vodStoreHomepageUrl;
  var match$1 = Context.I18n.getState(undefined);
  var locale = match$1.locale;
  var match$2 = match$1.labels.program;
  if (shopUrl !== undefined) {
    if (locale !== 0) {
      return null;
    } else {
      return React.createElement(Template_ProgramContent_Metas$VodDvd$Display, {
                  label: match$2.vod,
                  url: shopUrl,
                  availability: /* Available */0
                });
    }
  } else if (locale !== 0 || vodStoreHomepageUrl === undefined) {
    return null;
  } else {
    return React.createElement(Template_ProgramContent_Metas$VodDvd$Display, {
                label: match$2.vod_discover,
                url: vodStoreHomepageUrl,
                availability: /* NotAvailable */1
              });
  }
}

var VodDvd = {
  Display: Display,
  make: Template_ProgramContent_Metas$VodDvd
};

var audioSpacingPerSize = Atom_Icon_Css.getShirtSpacing;

function audioOffsetX(spacing) {
  return CssJs.px(-(spacing | 0) | 0);
}

function audioOffsetY(spacing) {
  return CssJs.px(-(spacing | 0) | 0);
}

function renderString(label, value) {
  if (value === "") {
    return null;
  } else {
    return React.createElement(React.Fragment, undefined, React.createElement(Template_ProgramContent.Label.make, {
                    label: label
                  }), React.createElement(Template_ProgramContent.Value.make, {
                    value: value
                  }));
  }
}

function renderAudioVersions(label, audioVersions) {
  if (audioVersions.length === 0) {
    return null;
  }
  var spacing = Atom_Icon_Css.getShirtSpacing("XL");
  var spacing$1 = Atom_Icon_Css.getShirtSpacing("XL");
  var spacing$2 = Atom_Icon_Css.getShirtSpacing("L");
  var spacing$3 = Atom_Icon_Css.getShirtSpacing("L");
  return React.createElement(React.Fragment, undefined, React.createElement(Template_ProgramContent.Label.make, {
                  label: label
                }), React.createElement(Atom_Row.make, {
                  alignSelf: Particle_Screen_Constants.alignSelfStart,
                  children: Belt_Array.mapWithIndex(audioVersions, (function (index, param) {
                          var label = param.label;
                          return React.createElement(Atom_Cell.make, {
                                      alignItems: Particle_Screen_Constants.alignItemsCenter,
                                      blockSpace: Particle_Screen_Constants.xxsVerticalBlockSpace,
                                      kind: /* ItemList */4,
                                      children: null,
                                      key: label + String(index)
                                    }, React.createElement(Atom_Icon_Internal.make, {
                                          icon: Type_Common.audioVersionCodeToIcon(param.code, "Text"),
                                          size: Particle_Screen_Ds.make(undefined, undefined, "XL", undefined, undefined, "L"),
                                          title: label
                                        }), React.createElement(Atom_Text.ScreenreadersLabel.make, {
                                          children: label
                                        }));
                        })),
                  display: Particle_Screen_Constants.displayInlineFlex,
                  kind: /* List */5,
                  rules: Particle_Screen_Ds.make(undefined, undefined, [CssJs.transform(CssJs.translate(CssJs.px(-(spacing | 0) | 0), CssJs.px(-(spacing$1 | 0) | 0)))], undefined, undefined, [CssJs.transform(CssJs.translate(CssJs.px(-(spacing$2 | 0) | 0), CssJs.px(-(spacing$3 | 0) | 0)))])
                }));
}

function renderGenre(genreLabel, param, onClick) {
  var url = param.url;
  var label = param.label;
  var match = Curry._1(Type_String.Program.Genre.Label.toString, label);
  if (match === "") {
    return null;
  } else {
    return React.createElement(React.Fragment, undefined, React.createElement(Template_ProgramContent.Label.make, {
                    label: genreLabel
                  }), url !== undefined ? React.createElement(Template_ProgramContent.Value.Link.make, {
                      value: Curry._1(Type_String.Program.Genre.Label.toString, label),
                      href: Curry._1(Type_String.Program.Genre.Url.toString, url),
                      onClick: onClick
                    }) : React.createElement(Template_ProgramContent.Value.make, {
                      value: Curry._1(Type_String.Program.Genre.Label.toString, label)
                    }));
  }
}

function renderMultiString(label, values) {
  if (values.length !== 0) {
    return React.createElement(React.Fragment, undefined, React.createElement(Template_ProgramContent.Label.make, {
                    label: label
                  }), React.createElement(Atom_Column.make, {
                    children: Belt_Array.mapWithIndex(values, (function (index, value) {
                            return React.createElement(Atom_Cell.make, {
                                        alignItems: Particle_Screen_Constants.alignItemsCenter,
                                        kind: /* ItemList */4,
                                        children: React.createElement(Template_ProgramContent.Value.make, {
                                              value: value
                                            }),
                                        key: label + String(index)
                                      });
                          })),
                    display: Particle_Screen_Constants.displayInlineFlex,
                    innerSpace: Particle_Screen_Constants.xxsInnerSpace,
                    kind: /* List */5
                  }));
  } else {
    return null;
  }
}

var gridRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
      CssJs.gridTemplateColumns([
            CssJs.fr(1),
            CssJs.fr(2)
          ]),
      CssJs.alignItems("baseline")
    ]);

var gridColumnGap = Particle_Screen_Ds.make(undefined, undefined, undefined, "L", undefined, "S");

var gridRowGap = Particle_Screen_Ds.make(undefined, undefined, undefined, "S", undefined, "XS");

function Template_ProgramContent_Metas$Infos(Props) {
  var meta = Props.meta;
  var _trackAmplitude = UseTrackingAmplitude.useUserAction("genre_button");
  var onClick = function (param) {
    Curry._1(_trackAmplitude, undefined);
  };
  return React.createElement(Atom_Grid.make, {
              children: Belt_Array.map(meta, (function (elem) {
                      var value = elem.value;
                      var label = elem.label;
                      switch (value.TAG | 0) {
                        case /* String */0 :
                            return renderString(label, value._0);
                        case /* AudioVersions */1 :
                            return renderAudioVersions(label, value._0);
                        case /* Genre */2 :
                            return renderGenre(label, value._0, onClick);
                        case /* MultiString */3 :
                            return renderMultiString(label, value._0);
                        
                      }
                    })),
              gapColumn: gridColumnGap,
              gapRow: gridRowGap,
              rules: gridRules
            });
}

var Infos = {
  renderString: renderString,
  renderAudioVersions: renderAudioVersions,
  renderGenre: renderGenre,
  renderMultiString: renderMultiString,
  gridRules: gridRules,
  gridColumnGap: gridColumnGap,
  gridRowGap: gridRowGap,
  make: Template_ProgramContent_Metas$Infos
};

function Template_ProgramContent_Metas(Props) {
  var teaser = Props.teaser;
  var meta = Props.meta;
  var parent = Props.parent;
  var buttons = Props.buttons;
  var ref_ = Props.ref_;
  var favoriteAvailability = Atom_FavoriteButton.availabilityFromTeaserFavorite(teaser.favoriteStatus);
  var match = teaser.title;
  var favoriteTitle;
  if (match !== undefined) {
    switch (match.TAG | 0) {
      case /* Displayed */0 :
          favoriteTitle = match._0;
          break;
      case /* AccessibilityOnly */1 :
      case /* HoverOnly */2 :
          favoriteTitle = undefined;
          break;
      
    }
  } else {
    favoriteTitle = undefined;
  }
  var tmp = {
    children: null
  };
  if (ref_ !== undefined) {
    tmp.ref_ = Caml_option.valFromOption(ref_);
  }
  var tmp$1 = {
    variant: Molecule_Partners.Molecule_Partners_Ds.program
  };
  if (teaser.partners !== undefined) {
    tmp$1.partners = Caml_option.valFromOption(teaser.partners);
  }
  return React.createElement(Atom_Column.make, tmp, React.createElement(Molecule_Partners.make, tmp$1), React.createElement(Atom_Row.make, {
                  blockSpace: Particle_Screen_Constants.mBottomBlockSpace,
                  children: null,
                  innerSpace: Particle_Screen_Constants.xsInnerSpace
                }, buttons, React.createElement(Atom_FavoriteButton.make, {
                      teaser: teaser,
                      styleVariation: /* Program */1,
                      title: favoriteTitle,
                      availability: favoriteAvailability
                    })), parent !== undefined ? React.createElement(Template_ProgramContent_Metas$Tags, {
                    parent: parent
                  }) : null, React.createElement(Template_ProgramContent_Metas$Infos, {
                  meta: meta
                }), React.createElement(Template_ProgramContent_Metas$VodDvd, {
                  shopUrl: teaser.shopUrl
                }));
}

Template_ProgramContent_Metas.displayName = "Template_ProgramContent_Metas";

var make = Template_ProgramContent_Metas;

export {
  Tags ,
  VodDvd ,
  audioSpacingPerSize ,
  audioOffsetX ,
  audioOffsetY ,
  Infos ,
  make ,
}
/* gridRules Not a pure module */
